/*
 * BestyBuys - keeps the dates of the product page Delivery timeline right.
 * The page already shows the dates when it is built; this script only re-works them with the visitor's
 * current time (in the shop's own time zone) so a page that was saved a while ago never shows old dates.
 * The rules are the same as in snippets/bb-delivery-timeline.liquid and everything it needs
 * (time zone, cutoff, days to skip, date style, month and day names, days per step) is read from
 * data attributes, so nothing is fixed here.
 */
(function () {
  'use strict';
  if (window.bbDeliveryTimeline) return;

  var DAY = 86400000;

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /* "+0530" -> 330 minutes */
  function offsetMinutes(tz) {
    var m = /^([+-])(\d{2}):?(\d{2})$/.exec(String(tz || '').trim());
    if (!m) return null;
    return (m[1] === '-' ? -1 : 1) * (parseInt(m[2], 10) * 60 + parseInt(m[3], 10));
  }

  /* A Date whose UTC fields read as the shop's wall clock */
  function shopNow(offset, nowMs) {
    var ms = typeof nowMs === 'number' ? nowMs : Date.now();
    return new Date(ms + (offset === null ? -new Date(ms).getTimezoneOffset() : offset) * 60000);
  }

  function addDays(date, n, skip) {
    var d = new Date(date.getTime());
    var count = Math.min(Math.max(parseInt(n, 10) || 0, 0), 40);
    for (var i = 0; i < count; i++) {
      d = new Date(d.getTime() + DAY);
      var wd = d.getUTCDay();
      if (skip === 'sun' && wd === 0) d = new Date(d.getTime() + DAY);
      else if (skip === 'satsun' && wd === 6) d = new Date(d.getTime() + 2 * DAY);
      else if (skip === 'satsun' && wd === 0) d = new Date(d.getTime() + DAY);
    }
    return d;
  }

  function format(d, fmt, months, days) {
    var day = d.getUTCDate();
    var mon = months[d.getUTCMonth()];
    if (fmt === 'day_mon') return day + ' ' + mon;
    if (fmt === 'weekday') return days[d.getUTCDay()] + ', ' + day + ' ' + mon;
    return mon + ' ' + pad(day);
  }

  function stepText(root, li, today, shift, nowFmt) {
    var from = parseInt(li.getAttribute('data-from'), 10) || 0;
    var to = Math.max(parseInt(li.getAttribute('data-to'), 10) || 0, from);
    var skip = root.getAttribute('data-skip') || 'none';
    var a;
    var b;
    if (from === 0 && to === 0) {
      a = today;
      b = today;
    } else {
      var base = new Date(today.getTime() + shift * DAY);
      a = addDays(base, from, skip);
      b = addDays(base, to, skip);
    }
    var ta = nowFmt(a);
    var tb = nowFmt(b);
    return ta === tb ? ta : ta + ' - ' + tb;
  }

  function update(root, nowMs) {
    var months = (root.getAttribute('data-months') || '').split(',');
    var days = (root.getAttribute('data-days') || '').split(',');
    if (months.length !== 12 || days.length !== 7) return;
    var now = shopNow(offsetMinutes(root.getAttribute('data-tz')), nowMs);
    var cutoff = parseInt(root.getAttribute('data-cutoff'), 10) || 0;
    var shift = cutoff > 0 && now.getUTCHours() >= cutoff ? 1 : 0;
    var fmt = root.getAttribute('data-format') || 'mon_day';
    var today = new Date(Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 12));
    var fmtFn = function (d) {
      return format(d, fmt, months, days);
    };
    root.querySelectorAll('.bb-dt__step').forEach(function (li) {
      if (li.getAttribute('data-live') !== '1') return;
      var el = li.querySelector('[data-bb-date]');
      if (!el) return;
      var text = stepText(root, li, today, shift, fmtFn);
      if (el.textContent !== text) el.textContent = text;
    });
  }

  function init() {
    document.querySelectorAll('[data-bb-dt]').forEach(function (root) {
      update(root);
    });
  }

  window.bbDeliveryTimeline = { update: update, addDays: addDays, format: format, offsetMinutes: offsetMinutes, init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  /* A tab left open past midnight or the cutoff time: refresh once a minute */
  setInterval(init, 60000);
})();
